/* eslint-disable jsdoc/require-returns */
/* eslint-disable jsdoc/require-returns-description */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

// eslint-disable-next-line import/no-extraneous-dependencies
const $ = require('jquery');
const util = require('../utils/util');
const captcha = require('../spam/captcha');
const page = require('../components/page');
const friendlyCaptcha = require('../widgets/friendlyCaptcha');
const progress = require('../utils/progress');
const showpassword = require('../utils/showpassword');
const googleRecaptcha = require('../components/googleRecaptcha');

const flyinLoginForm = {
    /**
     *
     * @param {Object} $flyInContainer - fly in container
     * @param {string} sessionKey - session item key
     */
    initLoginFormEvents($flyInContainer, sessionKey) {
        $flyInContainer.on('submit', '.flyout-ajax-login', async function (e) {
            e.preventDefault();

            const params = {
                format: 'ajax'
            };

            const $form = $(this);
            const $recaptcha = $form.find('.js-recaptcha');

            // Check if form has recaptcha enabled
            if ($recaptcha.length) {
                await googleRecaptcha.refreshRecaptchaElement($recaptcha);
            }

            const action = $form.attr('action');
            const formData = $form.serialize();
            const sessionValue = $form.data('sessionVal') || true;

            $.ajax({
                url: util.appendParamsToUrl(action, params),
                method: $form.attr('method'),
                data: formData,

                /**
                 * Asynchronous request success state
                 *
                 * @param {Object} response - response
                 */
                success(response) {
                    if (!response.error) {
                        if (sessionKey) {
                            sessionStorage.setItem(sessionKey, sessionValue);
                        }

                        page.refresh();
                    } else {
                        $form.find('.message').remove();

                        $form.prepend(
                            $('<div />', {
                                class: 'message error-form',
                                text: response.error
                            })
                        );

                        captcha.resetCaptcha($form[0]);
                    }
                },

                /**
                 * Asynchronous request error state
                 *
                 * @returns {void}
                 */
                error: () => captcha.resetCaptcha($form[0])
            });
        });

        let memberShopRegisterLoaded = false;
        const registerBtn = $flyInContainer.find('form .button-trans.frc-captcha-btn');

        $flyInContainer.on('submit', '#RegistrationForm', function (event) {
            const $memberShopForm = $(this);
            const action = $memberShopForm.attr('action');
            const method = $memberShopForm.attr('method');
            const sessionValue = $memberShopForm.data('sessionVal') || true;

            const $termsAndConditionsBtn = $('.create-account-terms');
            util.toggleFormSubmitEnabled($termsAndConditionsBtn);

            $(document).on('change', $termsAndConditionsBtn, function () {
                util.toggleFormSubmitEnabled($termsAndConditionsBtn);
            });

            event.preventDefault();

            if (!memberShopRegisterLoaded && $memberShopForm.attr('id') === 'RegistrationForm') {
                memberShopRegisterLoaded = true;
                $memberShopForm
                    .find('fieldset')
                    .children()
                    .not('.create-account-title, script')
                    .addClass('show-register-field');

                friendlyCaptcha.init('#RegistrationForm .frc-captcha');

                if (registerBtn && registerBtn.length) {
                    registerBtn.attr('disabled', true);
                }

                return;
            }

            const validate = $memberShopForm.valid();

            if (validate) {
                progress.show($('.member-shop-fly-in .ocd-content'));
                $.ajax({
                    url: action,
                    method,
                    data: $memberShopForm.serialize(),
                    dataType: 'json',
                    /**
                     *
                     * @param {Object} response response
                     */
                    success(response) {
                        if (!response.error) {
                            if (sessionKey) {
                                sessionStorage.setItem(sessionKey, sessionValue);
                            }
                            page.refresh();
                        } else {
                            $memberShopForm.find('.message').remove();
                            $memberShopForm.find('.validation-error').removeClass('validation-error');

                            if (response.error && response.error !== 'no-message') {
                                $memberShopForm.prepend(
                                    $('<div />', {
                                        class: 'message error-form',
                                        text: response.error
                                    })
                                );

                                for (const key in response) {
                                    if (key.startsWith('ff_')) {
                                        const elementId = key.replace('ff_', 'dwfrm_');
                                        const errorMessage = response[key];
                                        const $element = $(`#${elementId}`);

                                        if ($element.length) {
                                            const errorElementId = `${elementId}-error`;
                                            const $elementFormRow = $element.closest('.form-row');
                                            const $errorContainer = $('<div class="error-msg" />');

                                            $errorContainer.append(
                                                `<div id="${errorElementId}" class="error-msg-inner">${errorMessage}</div>`
                                            );
                                            $element.attr('aria-describedby', errorElementId);
                                            $element.attr('aria-invalid', 'true');
                                            $elementFormRow.addClass('validation-error');
                                            $elementFormRow.append($errorContainer);
                                        }
                                    }

                                    if (key.startsWith('cb_') && response[key]) {
                                        const $element = $(`#${key.replace('cb_', 'dwfrm_')}`);
                                        const $elementFormRow = $element.closest('.form-row');
                                        $elementFormRow.addClass('validation-error');
                                    }
                                }

                                captcha.resetCaptcha($memberShopForm[0]);
                            }
                        }

                        if (response.passwordMinLength) {
                            const $passwordField = $memberShopForm.find('.password-show-container');

                            $passwordField.append(
                                $('<div />', {
                                    class: 'error-msg'
                                }).append(
                                    $('<div />', {
                                        class: 'error-msg-inner',
                                        text: response.passwordMinLength
                                    })
                                )
                            );
                        }
                    },
                    /**
                     *
                     */
                    error: () => captcha.resetCaptcha($memberShopForm[0]),
                    /**
                     *
                     */
                    complete: () => progress.hide()
                });
            }
        });

        if (registerBtn && registerBtn.length) {
            registerBtn.removeAttr('disabled');
        }

        showpassword.init();
    }
};

module.exports = flyinLoginForm;
